module.exports = __webpack_public_path__ + "images/luxe-2-707d9a5c9a40f736ae3d6b05d9d71492.jpg";